import { Swiper } from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

const propelInit = function() {
const blocks = document.querySelectorAll('.block-card-slider');

blocks.forEach((block) => {
	const slider = block.querySelector('.swiper:not(.swiper-initialized)');
	const wrapper = block.querySelector('.swiper-wrapper');

	if (!slider || !wrapper) {
		return;
	}

	const slides = wrapper.children;

	Array.from(slides).forEach((slide) => {
		slide.classList.add('swiper-slide');
	});

	const mobileGap = block?.dataset?.mobileSliderGap ?? 8;
	const desktopGap = block?.dataset?.desktopSliderGap ?? 8;

	const settings = {
		loop: false,
		grabCursor: true,
		spaceBetween: mobileGap,
		slidesPerView: 1,
		modules: [A11y, Navigation, Scrollbar],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
			nextEl: slider.parentElement.querySelector('.swiper-button-next'),
		},
		breakpoints: {
			576: {
				slidesPerView: 1,
				spaceBetween: mobileGap,
			},
			768: {
				spaceBetween: desktopGap,
			},
			992: {
				slidesPerView: 4,
				spaceBetween: desktopGap,
			},
		},
		scrollbar: {
			el: slider.parentElement.querySelector('.swiper-scrollbar'),
			draggable: true,
		},
	};

	// Deferred two frames so Swiper reads slide geometry after the browser has
	// painted the swiper-slide class change, rather than forcing a synchronous
	// layout mid-script.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(slider, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['card-slider'] = window.propel.blocks['card-slider'] || {};
window.propel.blocks['card-slider'].script = propelInit;
